import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header Spacer */}
      <div className="h-20"></div>

      {/* Main Content Container */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Title Section - Header Block */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">TERMS OF SERVICE</h1>
          <p className="text-blue-600 text-sm mb-2">Last Updated: 8/1/2025</p>
          <p className="text-gray-600 text-sm">
            This document is provided for informational purposes only and does not constitute legal advice. Please consult with 
            licensed legal counsel to review and adapt this document for full enforceability in your jurisdiction.
          </p>
        </div>

        {/* Terms Sections - Indented from main title */}
        <div className="space-y-6 pl-8">
          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. User Agreement / Consent to Terms</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              By engaging in using www.mountoliveplumbing.com ("Mount Olive Plumbing services from Mount Olive Plumbing, Heating, and Air Conditioning, LLC 
              website), making an appointment, and/or accepting our quotes for services and others, users agree to be bound by these Terms & Conditions 
              ("Terms") and applicable laws & regulations. If you do not accept all terms and conditions stated herein, please do not utilize our website or services knowledge.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. Eligibility (Age and Location)</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Mount Olive Plumbing, Heating, and Air Conditioning, LLC is located in Budd Lake, United States, performs in Morris County and surrounding areas. You 
              must be at least 18 years of age or have parental or legal guardian authorization to use our service or book appointments.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. Use Restrictions</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">Users agree not to:</p>
            <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
              <li>Engage in actions or unauthorized use of the Site or services</li>
              <li>Attempt to breach, probe, scan, or test at anytime any part of the Site or interfere with its functionality</li>
              <li>Submit false, misleading, fraudulent, or harmful information when requesting services</li>
              <li>Use our Site or attempt to use our Site for uploading or transmitting content that violates</li>
              <li>Attempt to send links to harmful information or redirect Site users to malicious third-party websites</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. Intellectual Property Ownership</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              All website content, logos, text, graphics, photos, videos, and designs are the exclusive property of Mount Olive Plumbing, Heating, and Air 
              Conditioning, LLC. Users are granted a non-exclusive, non-transferrable, revocable license strictly as strictly prohibited and may result in legal action.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. Payments, Refunds, and Deposits</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">Payments are due upon completion of services unless otherwise agreed.</p>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              Deposits may be required for certain projects, including large-scale installations or special order parts.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              Refund and cancellation policies depend upon service agreements and are negotiated on a case-by-case basis.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">We accept the following payment methods.</p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. User Responsibilities</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              You must provide accurate property details, service needs, and access to your premises as agreed.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              You are responsible for receiving estimates and must honor service scheduling parties.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              You must notify us promptly of cancellations prior to arrival at the property, as detailed in our responsibility of the property owner.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">7. Disclaimers & No Guarantees</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              Mount Olive Plumbing uses website tools provided by certain response times. No guarantee is made for specific arrival windows or emergency 
              response time claims.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              Properties are taken on change losses on our Site assistance or additional required work.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Warranties are limited to the existing package of basic charge or updates, failures caused by third-party products or manufacturer defects, or events 
              beyond our control (acts of God) unless otherwise or force majeure events.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">8. Limitation of Liability</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">
              To the maximum extent permitted by law, Mount Olive Plumbing, its owners, employees, or contractors shall not be liable for indirect, incidental, special, 
              consequential, or punitive damages arising out of:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm mb-2">
              <li>Your use of our services</li>
              <li>Loss of data, profits, or property value related to services performed</li>
            </ul>
            <p className="text-gray-600 text-sm leading-relaxed">
              Total liability under any claim shall not exceed the amount paid by the customer for the specific service in question.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">9. Indemnification</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              You agree to defend, indemnify, and hold harmless Mount Olive Plumbing, its affiliates, employees, contractors, and agents from all claims, damages, 
              costs, and expenses including legal fees arising out of your misuse of the Site's services, violation of these Terms, or violation of any applicable laws.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">10. Termination of Access or Services</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-2">We reserve the right to:</p>
            <ul className="list-disc pl-6 space-y-1 text-gray-600 text-sm">
              <li>Terminate or suspend your access to the Site or services at our sole discretion for any breach of these Terms or normal conduct</li>
              <li>Refuse service upon violation of safety for safety, compliance, or other valid business reasons</li>
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">11. Third-Party Links and Services</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              We may link directly to or from or use third-party service providers, if practical, payment processors. We are not responsible for the content, policies, 
              or practices of third-party sites not offered by their owners to their sites.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">12. Governing Law</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              These Terms shall be governed by the laws of the State of New Jersey, United States, without regard to conflict of law rules. Any disputes shall be resolved 
              through binding arbitration in Morris, New Jersey.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">13. Right to Modify Terms</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              We may update these Terms periodically. Updates will be posted on this page with a revised "Last Updated" date. Continued use of our Site or services 
              constitutes acceptance of the updated Terms.
            </p>
          </div>
        </div>

       
      </div>
    </div>
  );
};

export default TermsOfService;